<template>
  <div v-if="role === 'admin'" class="t bold m-lx2">Admin</div>
  <donut-selector-single-static v-else v-model="roleSelection" :options="roleOptions" :loading="isLoading" />
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import Network from 'lib/api/network';

  const props = defineProps({
    user: { type: Object, required: true },
  });
  const { state, commit, dispatch } = useStore();

  const role = computed(() => state.pointsLeaderboard.asyncValuesByUser[props.user.id]?.role);
  const isLoading = ref(false);

  const roleOptions = [{ label: 'Member', value: 'member' }, { label: 'Manager', value: 'manager' }];
  const roleSelection = computed({
    get() { return roleOptions.find(o => role.value === o.value); },
    set({ value }) {
      // Prepare for the network call by storing the current value, update the asyncValue assuming it will succeed, and set that it's loading
      const originalRole = role.value;
      commit('pointsLeaderboard/updateAsyncValuesForUser', { id: props.user.id, key: 'role', value, markColOutdated: true });
      isLoading.value = true;
      // Make the network call
      Network.put(`/points/wallets/${props.user.id}`, { role: value }, {
        success: (data) => {
          if (!data.isCustom) {
            // If this user doesn't have a custom allowance, we're going to want to update the value in the Allowance col as well
            commit('pointsLeaderboard/updateAsyncValuesForUser', { id: props.user.id, key: 'allowance', value: data.allowance, markColOutdated: true });
          }
        },
        error: (error) => {
          // Reset the asyncValue and set an error toast
          commit('pointsLeaderboard/updateAsyncValuesForUser', { id: props.user.id, key: 'role', value: originalRole, markColOutdated: true });
          dispatch('setErrorToast', `Could not update role for ${props.user.name}`);
        },
        complete: () => { isLoading.value = false; },
      });
    },
  });
</script>
